<template>
  <div class="shadow-left">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ShadowedWrapper'
}
</script>
